import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosinhagadfortbusonrent() {



  const cardData =
  {
    keyword: 'Pune to Sinhagad Fort Bus on rent in Pune ',
    heading: 'Sanavi Travels: Pune to Sinhagad Fort Bus on rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable Pune to Sinhagad Fort Bus on Rent in Pune, providing safe, comfortable, and well-organized transportation solutions for families, school and college groups, corporate outings, picnic tours, and tourists planning a heritage trip to Sinhagad Fort from Pune. Our fleet includes AC and Non-AC buses ranging from 20, 25, 30, 32, 35, 40, 45 to 50 seaters, along with tempo travellers on request, all well-maintained with spacious seating and adequate luggage space for a smooth short-distance journey. With experienced hill-route drivers, flexible half-day and full-day rental packages, transparent pricing, and punctual service, Sanavi Travels ensures a safe and enjoyable travel experience. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering Sinhagad Fort and nearby picnic spots. Choose Sanavi Travels for trusted Pune to Sinhagad Fort bus rental services, delivering comfort, safety, and a memorable heritage and nature travel experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical monument and a proud symbol of Maratha power. Once the administrative seat of Peshwa Bajirao I, it features massive stone walls, grand gateways like the Delhi Darwaza, and landscaped courtyards. Although a major fire destroyed much of the structure, the remaining ruins still reflect royal grandeur. The evening light-and-sound show narrates the legacy of the Marathas. Shaniwar Wada remains the cultural and historical heart of Pune."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a landmark deeply connected with India’s freedom movement. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it functions as a museum showcasing photographs, personal belongings, and historical records. The palace is surrounded by lush gardens and elegant Italian-style architecture. It stands as a symbol of sacrifice, peace, and national pride."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual destination, dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts thousands of devotees every day. During Ganesh Chaturthi, the temple becomes the center of grand celebrations, processions, and cultural events. The temple trust is also known for its extensive charitable work. Dagdusheth Ganpati is the spiritual soul of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort famous for the heroic sacrifice of Tanaji Malusare in 1670 for Chhatrapati Shivaji Maharaj. Perched atop a rugged hill, the fort offers panoramic views of the Sahyadri mountain range. Visitors can trek or drive up to explore ancient gates, memorials, and viewpoints. Sinhagad is a perfect blend of history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in the bustling city center, the temple offers a calm and meditative atmosphere. Its monolithic pillars and ancient carvings reflect early Indian architectural excellence. Pataleshwar is one of Pune’s finest hidden heritage sites."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural heritage. The collection includes musical instruments, traditional household items, sculptures, and ornaments. The recreated Mastani Mahal is a major attraction. The museum is an essential destination for history lovers and cultural enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks and offers stunning panoramic views of the city. After climbing 103 stone steps, visitors reach the Parvati Temple complex built during the Peshwa era. Smaller temples and a museum add historical value. Sunrise and sunset views from Parvati Hill are especially mesmerizing."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from across the globe. Spread across serene landscaped gardens, it offers meditation programs, wellness therapies, and mindfulness practices. The calm environment promotes relaxation and inner peace. Osho Ashram represents Pune’s global spiritual and wellness identity."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, manicured lawns, and seasonal flowers create a tranquil setting. It is popular among families, walkers, and photography enthusiasts. The garden offers a refreshing escape from city life."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure and picnic spot near Pune, especially during monsoon and evenings. The vast reservoir, cool breeze, and surrounding hills create a scenic environment. Local food stalls enhance the visitor experience. The dam also serves as the gateway to Sinhagad Fort, making it a perfect short getaway."
  }
]
,




"services": [
  {
    "name": "Pune to Sinhagad Fort Bus on rent in Pune",
    "description": "Pune to Sinhagad Fort Bus on rent in Pune offers comfortable and reliable buses for groups traveling from Pune to Sinhagad Fort. Ideal for day trips, trekking groups, and family outings, these buses provide spacious seating, luggage storage, and professional drivers to ensure a safe and smooth journey. Flexible rental options make planning trips to Sinhagad Fort hassle-free, providing convenience, comfort, and an enjoyable travel experience for all passengers."
  },
  {
    "name": "Sinhagad Fort Bus Hire Pune",
    "description": "Sinhagad Fort Bus Hire Pune provides well-maintained buses for private or group trips to Sinhagad Fort from Pune. Equipped with comfortable seating and safety features, these buses are perfect for families, friends, and corporate groups. Professional chauffeurs ensure punctual pickups and smooth rides, making the journey stress-free and enjoyable."
  },
  {
    "name": "AC Bus Pune to Sinhagad",
    "description": "AC Bus Pune to Sinhagad offers air-conditioned travel for a cool and comfortable ride to Sinhagad Fort. Ideal for long-distance day trips and hot summer days, these buses provide spacious interiors, smooth rides, and reliable service. Passengers can relax and enjoy the scenic journey while ensuring safe and timely travel."
  },
  {
    "name": "Luxury Sinhagad Tour Bus",
    "description": "Luxury Sinhagad Tour Bus provides premium, well-appointed buses for an elegant travel experience to Sinhagad Fort. Equipped with comfortable reclining seats, entertainment options, and ample luggage space, these buses are ideal for VIP groups, corporate outings, or family trips seeking extra comfort and style."
  },
  {
    "name": "Family Sinhagad Trip Bus",
    "description": "Family Sinhagad Trip Bus ensures a safe, spacious, and comfortable journey for families visiting Sinhagad Fort. With child-friendly features, luggage space, and reliable drivers, this service prioritizes family convenience and comfort during one-day trips or weekend excursions."
  },
  {
    "name": "Group Travel Sinhagad Bus",
    "description": "Group Travel Sinhagad Bus caters to large groups, school trips, trekking teams, or corporate outings to Sinhagad Fort. Spacious seating, professional drivers, and organized pick-up/drop-off arrangements make group travel hassle-free, safe, and enjoyable."
  },
  {
    "name": "Affordable Sinhagad Bus Hire",
    "description": "Affordable Sinhagad Bus Hire provides budget-friendly travel options for groups visiting Sinhagad Fort without compromising on comfort or safety. Reliable buses, professional drivers, and flexible booking options make this service perfect for cost-conscious travelers seeking convenience and comfort."
  },
  {
    "name": "Chauffeur Driven Sinhagad Bus",
    "description": "Chauffeur Driven Sinhagad Bus provides experienced drivers who handle the route, traffic, and safety, allowing passengers to relax and enjoy their journey. Ideal for private tours, family trips, and corporate groups, this service ensures stress-free travel to Sinhagad Fort."
  },
  {
    "name": "Best Sinhagad Tour Bus Pune",
    "description": "Best Sinhagad Tour Bus Pune offers top-quality buses and professional service for a superior travel experience to Sinhagad Fort. Comfortable seating, skilled drivers, and reliable service ensure a smooth, safe, and enjoyable journey for all passengers."
  },
  {
    "name": "Pune Sinhagad Travel Bus",
    "description": "Pune Sinhagad Travel Bus provides dependable and comfortable buses for trips between Pune and Sinhagad Fort. With spacious seating, luggage-friendly interiors, and professional chauffeurs, this service guarantees smooth and convenient travel for families, friends, and trekking groups."
  },
  {
    "name": "Tourist Bus Hire Sinhagad",
    "description": "Tourist Bus Hire Sinhagad offers dedicated buses for tourists visiting Sinhagad Fort from Pune. Well-maintained and spacious, these buses cater to sightseeing, trekking, and group trips, providing safety, comfort, and convenience throughout the journey."
  },
  {
    "name": "One Day Trip Bus Sinhagad",
    "description": "One Day Trip Bus Sinhagad provides buses for short trips or day tours from Pune to Sinhagad Fort. Ideal for trekking groups, family outings, and sightseeing trips, these buses ensure timely pick-up and drop-off, comfortable seating, and a stress-free travel experience."
  },
  {
    "name": "Trekking Trip Bus Pune",
    "description": "Trekking Trip Bus Pune specializes in transporting trekking groups from Pune to Sinhagad Fort and surrounding areas. Spacious buses, luggage-friendly interiors, and experienced drivers ensure a safe, convenient, and enjoyable trekking trip for adventure enthusiasts."
  },
  {
    "name": "Weekend Tour Bus Sinhagad",
    "description": "Weekend Tour Bus Sinhagad offers comfortable buses for weekend getaways from Pune to Sinhagad Fort. Perfect for families, friends, and trekking groups, these buses provide spacious seating, reliable service, and convenient pick-up and drop-off arrangements."
  },
  {
    "name": "Sinhagad Fort Travel Service",
    "description": "Sinhagad Fort Travel Service provides complete bus travel solutions for trips from Pune to Sinhagad Fort. With well-maintained vehicles, professional drivers, and organized itineraries, this service ensures safe, comfortable, and hassle-free travel for tourists, families, and corporate groups."
  }
],
"tableData": [
  ["Pune to Sinhagad Fort Bus on rent in Pune", "Sinhagad Fort Bus Hire Pune"],
  ["AC Bus Pune to Sinhagad", "Luxury Sinhagad Tour Bus"],
  ["Family Sinhagad Trip Bus", "Group Travel Sinhagad Bus"],
  ["Affordable Sinhagad Bus Hire", "Chauffeur Driven Sinhagad Bus"],
  ["Best Sinhagad Tour Bus Pune", "Pune Sinhagad Travel Bus"],
  ["Tourist Bus Hire Sinhagad", "One Day Trip Bus Sinhagad"],
  ["Trekking Trip Bus Pune", "Weekend Tour Bus Sinhagad"],
  ["Sinhagad Fort Travel Service", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Sinhagad Fort Bus on Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable bus rental services for Pune to Sinhagad Fort trips, perfect for family outings, group tours, school excursions, and leisure travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-serviced buses with ample seating and luggage space for a smooth and enjoyable journey to Sinhagad Fort."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune city roads and routes to Sinhagad Fort, ensuring safe, punctual, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Pune to Sinhagad Fort bus rentals, including fuel, tolls, and driver allowances for a stress-free booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel planning, and itinerary changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from half-day, full-day, or customized bus rental plans tailored to your Pune to Sinhagad Fort travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Sinhagad Fort bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Sinhagad Fort bus on rent?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained buses for travel from Pune to Sinhagad Fort.'
  },
  {
    question: 'How can I book a bus for Pune to Sinhagad Fort with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are available for Pune to Sinhagad Fort travel?',
    answer: 'We provide air-conditioned and non-AC buses in various seating capacities suitable for group travel.'
  },
  {
    question: 'Are drivers included in the bus rental?',
    answer: 'Yes, all rentals include experienced and professional drivers familiar with Pune and Sinhagad Fort routes.'
  },
  {
    question: 'Is the Pune to Sinhagad Fort bus service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Pune to Sinhagad Fort bus rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your travel needs.'
  },
  {
    question: 'What payment options are available for bus bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Sinhagad Fort trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinod Shelke',
    feedback: 'Booked a Pune to Sinhagad Fort bus with Sanavi Travels. Comfortable seats, smooth ride, and excellent driver service made our trip memorable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ayesha Khan',
    feedback: 'Great experience! Buses were clean, pick-up was on time, and the journey to Sinhagad Fort was very pleasant. Highly recommended!',
    rating: 5
  }
];


































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Sinhagad Fort Bus on Rent - Sanavi Travels",
  "description": "Book Pune to Sinhagad Fort bus on rent with Sanavi Travels. AC and luxury buses for family trips, group travel, trekking trips, weekend tours, and one-day Sinhagad Fort sightseeing with chauffeur-driven, safe, and affordable bus hire services.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Pune to Sinhagad Fort Bus on Rent Starting from ₹40 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses from Pune to Sinhagad Fort with Sanavi Travels. Best bus hire for family trips, group travel, trekking trips, weekend tours, and one-day Sinhagad Fort travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosinhagadfortbusonrent;